"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlProcessingPaymentsValidation = void 0;
const PaymentTerminalControlOfflinePayloadValidation_1 = require("./PaymentTerminalControlOfflinePayloadValidation");
const PaymentTransactionValidation_1 = require("./PaymentTransactionValidation");
class PaymentTerminalControlProcessingPaymentsValidation {
    static isValid(entity) {
        // Validate entity.offline_payloads for existence and correct type.
        if (entity.offline_payloads == undefined)
            return false;
        if (!Array.isArray(entity.offline_payloads))
            return false;
        if (!entity.offline_payloads.every((elem) => {
            if (!PaymentTerminalControlOfflinePayloadValidation_1.PaymentTerminalControlOfflinePayloadValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // Validate entity.pending_captures for existence and correct type.
        if (entity.pending_captures == undefined)
            return false;
        if (!Array.isArray(entity.pending_captures))
            return false;
        if (!entity.pending_captures.every((elem) => {
            if (!PaymentTransactionValidation_1.PaymentTransactionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.PaymentTerminalControlProcessingPaymentsValidation = PaymentTerminalControlProcessingPaymentsValidation;
